import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import PrimaryBox from 'components/Advanced_User/OpenHAB_IP_Camera_Binding/PrimaryBox';
import NavButtons from 'components/Advanced_User/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Pure-FTPd auf einem Raspberry Pi",
  "path": "/Erweitert/openHABian_auf_Raspberry_Pi/Projects/FTP_Snapshot/Pure-FTPd/",
  "dateChanged": "2018-10-18",
  "author": "Mike Polinowski",
  "excerpt": "FTP (File Transfer Protocol) kann verwendet werden, um Dateien zwischen einem Raspberry Pi und einem anderen Computer zu übertragen. openHABian zielt darauf ab, ein sich selbst konfigurierendes Linux-System-Setup bereitzustellen, das speziell auf die Bedürfnisse jedes Raspberry-Pi-Benutzers zugeschnitten ist. Steuern Sie Ihre INSTAR IP-Kamera mit Ihrem Heimautomatisierungssystem. Kompatibel mit den Kameramodellen IN-6001 HD, IN-6012 HD, IN-6014 HD, IN-5905 HD, IN-5907 HD, IN-7011 HD, IN-8003 Full HD, IN-8015 Full HD, IN-9008 Full HD, IN-9020 Full HD",
  "image": "./AU_SearchThumb_openHABian.png",
  "social": "/images/Search/AU_SearchThumb_openHABian.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_Advanced_OpenHAB2_white.webp",
  "chapter": "Advanced User",
  "category": "smarthome",
  "type": "OpenHAB"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Pure-FTPd auf einem Raspberry Pi' dateChanged='2018-10-18' author='Mike Polinowski' tag='INSTAR IP Camera' description='FTP (File Transfer Protocol) kann verwendet werden, um Dateien zwischen einem Raspberry Pi und einem anderen Computer zu übertragen. openHABian zielt darauf ab, ein sich selbst konfigurierendes Linux-System-Setup bereitzustellen, das speziell auf die Bedürfnisse jedes Raspberry-Pi-Benutzers zugeschnitten ist. Steuern Sie Ihre INSTAR IP-Kamera mit Ihrem Heimautomatisierungssystem. Kompatibel mit den Kameramodellen IN-6001 HD, IN-6012 HD, IN-6014 HD, IN-5905 HD, IN-5907 HD, IN-7011 HD, IN-8003 Full HD, IN-8015 Full HD, IN-9008 Full HD, IN-9020 Full HD' image='/images/Search/AU_SearchThumb_openHABian.png' twitter='/images/Search/AU_SearchThumb_openHABian.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Advanced_User/openHABian_on_Raspberry_Pi/Projects/FTP_Snapshot/Pure-FTPd/' locationFR='/fr/Advanced_User/openHABian_on_Raspberry_Pi/Projects/FTP_Snapshot/Pure-FTPd/' crumbLabel="OpenHAB" mdxType="BreadCrumbs" />
 
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "pure-ftpd-auf-einem-raspberry-pi",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#pure-ftpd-auf-einem-raspberry-pi",
        "aria-label": "pure ftpd auf einem raspberry pi permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Pure-FTPd auf einem Raspberry Pi`}</h1>
    {
      /* TOC */
    }
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#installation"
        }}>{`Installation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#grundlegende-konfigurationen"
        }}>{`Grundlegende Konfigurationen`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#ftp-home-verzeichnis-virtueller-benutzer-und-benutzergruppe"
        }}>{`FTP-Home-Verzeichnis, virtueller Benutzer und Benutzergruppe`}</a></li>
    </ul>
    {
      /* /TOC */
    }
    <EuiSpacer mdxType="EuiSpacer" />
    <PrimaryBox mdxType="PrimaryBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Wir wollen mit dem FTP (File Transfer Protocol) Snapshots zwischen unserer INSTAR IP Kamera und unserem Raspberry Pi übertragen. Befolgen Sie die folgenden Schritte, um einen FTP-Server einzurichten.`}</p>
    <h2 {...{
      "id": "installation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#installation",
        "aria-label": "installation permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Installation`}</h2>
    <ol>
      <li parentName="ol">{`Verwenden Sie Ihr SSH-Terminal (Windows-Benutzer können das kostenlose Terminal von `}<a parentName="li" {...{
          "href": "https://mobaxterm.mobatek.net/download.html"
        }}>{`Mobaterm`}</a>{`verwenden) um sich mit Ihrem Pi zu verbinden (`}<strong parentName="li">{`Standard Login: Benutzer=openhabian und Kennwort=openhabian`}</strong>{` für die `}<a parentName="li" {...{
          "href": "/de/Erweitert/openHABian_auf_Raspberry_Pi/"
        }}>{`openHABian Installation`}</a>{`).`}</li>
      <li parentName="ol">{`Installieren Sie Pure-FTPd mit der folgenden Befehlszeile im Terminal: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`sudo apt-get install pure-ftpd`}</code>{`.`}</li>
    </ol>
    <h2 {...{
      "id": "grundlegende-konfigurationen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#grundlegende-konfigurationen",
        "aria-label": "grundlegende konfigurationen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Grundlegende Konfigurationen`}</h2>
    <ol>
      <li parentName="ol">{`Wir müssen eine neue Benutzergruppe namens `}<strong parentName="li">{`ftpgroup`}</strong>{` und einen neuen Benutzer namens `}<strong parentName="li">{`ftpuser`}</strong>{` für FTP-Benutzer erstellen und sicherstellen, dass dieser "Benutzer" keine Anmeldeberechtigung und kein Home-Verzeichnis hat:`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`groupadd`}</span>{` ftpgroup
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useradd`}</span>{` ftpuser -g ftpgroup -s /sbin/nologin -d /dev/null`}</code></pre></div>
    <h2 {...{
      "id": "ftp-home-verzeichnis-virtueller-benutzer-und-benutzergruppe",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#ftp-home-verzeichnis-virtueller-benutzer-und-benutzergruppe",
        "aria-label": "ftp home verzeichnis virtueller benutzer und benutzergruppe permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`FTP-Home-Verzeichnis, virtueller Benutzer und Benutzergruppe`}</h2>
    <ol>
      <li parentName="ol">{`Wir haben bereits ein öffentliches Verzeichnis im Ordner `}<em parentName="li">{`/.node-red/static/`}</em>{` in unserem `}<em parentName="li">{`openhabian`}</em>{` Home-Verzeichnis erstellt. Erstellen Sie dort ein neues Verzeichnis `}<em parentName="li">{`ftp`}</em>{` mit einem Unterordner für unsere erste Kamera (in meinem Fall ist es `}<em parentName="li">{`officecam`}</em>{`):`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`mkdir`}</span>{` /home/openhabian/.node-red/static/ftp/officecam/`}</code></pre></div>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Sie werden nach Ihrem Passwort gefragt, das standardmäßig `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`openhabian`}</code>{` ist - aber Sie haben es vielleicht in einem `}<a parentName="li" {...{
          "href": "/de/Erweitert/openHABian_auf_Raspberry_Pi/OpenHAB_Setup/#securing-your-installation"
        }}>{`früheren Schritt`}</a>{` geändert.`}</li>
      <li parentName="ol">{`Stellen Sie sicher, dass das Verzeichnis für `}<strong parentName="li">{`ftpuser`}</strong>{` zugänglich ist, damit unsere Kamera dort Dateien lesen und schreiben kann:`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`chown`}</span>{` -R ftpuser:ftpgroup /home/openhabian/.node-red/static/ftp/officecam/`}</code></pre></div>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Create a virtual user named `}<strong parentName="li">{`upload`}</strong>{`, mapping the virtual user to `}<strong parentName="li">{`ftpuser`}</strong>{` and  `}<strong parentName="li">{`ftpgroup`}</strong>{`, setting home directory `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`/home/openhabian/.node-red/static/ftp/`}</code>{`, and record password of the user in database. Notice that we set the path to `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`/home/openhabian/.node-red/static/ftp/`}</code>{` and NOT to `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`/home/openhabian/.node-red/static/ftp/officecam`}</code>{` - this way we can use the same FTP user for all our cameras and just have to assign different upload directories in the `}<a parentName="li" {...{
          "href": "/de/Web_User_Interface/1080p_Serie/Features/FTP/"
        }}>{`FTP Configuration`}</a>{` of our cameras - `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`./officam`}</code>{` in case of our first camera. In your case `}<em parentName="li">{`it might make sense`}</em>{` to use a different FTP user with a different home directory for each camera? You can make that decision here:`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` pure-pw `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useradd`}</span>{` upload -u ftpuser -g ftpgroup -d /home/openhabian/.node-red/static/ftp/ -m`}</code></pre></div>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Geben Sie ein Kennwort für diesen virtuellen Benutzer ein, wenn Sie dazu aufgefordert werden.`}</li>
      <li parentName="ol">{`Als nächstes richten Sie eine virtuelle Benutzerdatenbank ein, indem Sie Folgendes eingeben:`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` pure-pw mkdb`}</code></pre></div>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Zu guter Letzt definieren Sie eine Authentifizierungsmethode, indem Sie eine Verknüpfung der Datei erstellen `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`/etc/pure-ftpd/conf/PureDB`}</code>{`:`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`ln`}</span>{` -s /etc/pure-ftpd/conf/PureDB /etc/pure-ftpd/auth/60puredb`}</code></pre></div>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Starten Sie danach den FTP Dienst neu:`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`sudo service pure-ftpd restart`}</code></pre></div>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Sie können den FTP-Upload mit Ihrer INSTAR-Kamera mit der FTP-Test-Funktion testen:`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/c3c36b9bbd1da42782d1b1ff36b80e00/e9beb/Node-RED_OpenHAB_Projects_Pure-FTPd_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "71.30434782608695%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACzElEQVQoz22PXUhTcRjGD1JC5gez1JjiRws1Zpo6Nd1OudZEoxQzofkFYRejRSjJJtvZ2dzm0lAHBYE3XhVhQniym5ISqRASayUzhMQ8286cSJvZ2dn52PmHLELLh+fufZ/397zQ9b4n1/qmWi1Yi2Wq2fR8r7FmE3YVnWy3vVD1YfcevaUpMhjcCgQCDMM4nU7IPr5on1q/i3msz9z6p2uGXUae4sgErh9f65/02DHvxNy6z4u7lpZcLheO47Ozs9CG3wcAy0dY8L84mqd/AZ6JTgmvR3ZWKi4UZ2VlxkCQTFoJEQTBMAzHcQAAfpcjPE9RFE3TDMPQNAMA8Ho855UK5cVauUIef/DAOVi2E6ZpmmX3IZMkGQ6HWZZlGIbnebfbXXvpcm1DQ119fZpAUA3De8j7hiORSPQ0juNNqtYOtaaptS1HmFFdJd0JUxRFkmR0g9ul7e3tQCBAURTD7NT2uN3yC4oKmbQShvNyRHKp7A85Wu8fMstxJEn+DfsIolxSknH0yHGRKEmQVF5RBhGElw5T4RAJeB4AMDY2ptVpUYtFi/Y5HI4fgeDO4VCI5yLrBFFRWnrimDA5NQWKgcrKJRDh8/EA0FwEALAV3FLWKEVZooLcU7nlZ6pq632e79FfAAAbfr+kpDguMS5BkBB7OFZWDUP+tWUwPxp59wB8Gf9JhhobGktrSmE9LG47fVLRPjr9zfsY8w7e9w09JBacRcVFhxLj0rOz04TpSoUCcn1e2FycIT5Ob36dW1ldrZHXiOsKyhBJXmFhsfIK9mZ+9f2HlZevV1/NLH9yant1Go3mdlfXrZuanu5uSG9ADOZ+1DpgGxw2IkhuXm5yQnJqfEqKMFOUn2829A44RmzDQ3bHiNXeb4vKarXZbBarFdLpdNqeO/pencloNJvNarVa1aJq62hTqVQ3OjuNqAlFjCiCoAhiQlHTXv0Gmpsm+RQLD40AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c3c36b9bbd1da42782d1b1ff36b80e00/e4706/Node-RED_OpenHAB_Projects_Pure-FTPd_01.avif 230w", "/de/static/c3c36b9bbd1da42782d1b1ff36b80e00/d1af7/Node-RED_OpenHAB_Projects_Pure-FTPd_01.avif 460w", "/de/static/c3c36b9bbd1da42782d1b1ff36b80e00/b6582/Node-RED_OpenHAB_Projects_Pure-FTPd_01.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/c3c36b9bbd1da42782d1b1ff36b80e00/a0b58/Node-RED_OpenHAB_Projects_Pure-FTPd_01.webp 230w", "/de/static/c3c36b9bbd1da42782d1b1ff36b80e00/bc10c/Node-RED_OpenHAB_Projects_Pure-FTPd_01.webp 460w", "/de/static/c3c36b9bbd1da42782d1b1ff36b80e00/87ca7/Node-RED_OpenHAB_Projects_Pure-FTPd_01.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c3c36b9bbd1da42782d1b1ff36b80e00/81c8e/Node-RED_OpenHAB_Projects_Pure-FTPd_01.png 230w", "/de/static/c3c36b9bbd1da42782d1b1ff36b80e00/08a84/Node-RED_OpenHAB_Projects_Pure-FTPd_01.png 460w", "/de/static/c3c36b9bbd1da42782d1b1ff36b80e00/e9beb/Node-RED_OpenHAB_Projects_Pure-FTPd_01.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/c3c36b9bbd1da42782d1b1ff36b80e00/e9beb/Node-RED_OpenHAB_Projects_Pure-FTPd_01.png",
              "alt": "INSTAR Camera FTP Setup",
              "title": "INSTAR Camera FTP Setup",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Gehen Sie zurück zu Ihrem Terminal, gehen Sie zum Upload-Verzeichnis und listen Sie alle Dateien auf:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` /home/openhabian/.node-red/static/ftp/officecam
ll`}</code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/13405dd7007b0262f1c3b77a0aa325bc/e9beb/Node-RED_OpenHAB_Projects_Pure-FTPd_02.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "3.4782608695652173%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAABCAYAAADeko4lAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAR0lEQVQI1y3FSw6AIAxAQU+kG6UWqHyKCd7/QM/EuJjMUudGfTasr+xJEG+EVtDbkf7vFRmOz0HOQjbFLqXUhMbjE1Mg2ckLUyYiG0VKkS0AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/13405dd7007b0262f1c3b77a0aa325bc/e4706/Node-RED_OpenHAB_Projects_Pure-FTPd_02.avif 230w", "/de/static/13405dd7007b0262f1c3b77a0aa325bc/d1af7/Node-RED_OpenHAB_Projects_Pure-FTPd_02.avif 460w", "/de/static/13405dd7007b0262f1c3b77a0aa325bc/b6582/Node-RED_OpenHAB_Projects_Pure-FTPd_02.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/13405dd7007b0262f1c3b77a0aa325bc/a0b58/Node-RED_OpenHAB_Projects_Pure-FTPd_02.webp 230w", "/de/static/13405dd7007b0262f1c3b77a0aa325bc/bc10c/Node-RED_OpenHAB_Projects_Pure-FTPd_02.webp 460w", "/de/static/13405dd7007b0262f1c3b77a0aa325bc/87ca7/Node-RED_OpenHAB_Projects_Pure-FTPd_02.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/13405dd7007b0262f1c3b77a0aa325bc/81c8e/Node-RED_OpenHAB_Projects_Pure-FTPd_02.png 230w", "/de/static/13405dd7007b0262f1c3b77a0aa325bc/08a84/Node-RED_OpenHAB_Projects_Pure-FTPd_02.png 460w", "/de/static/13405dd7007b0262f1c3b77a0aa325bc/e9beb/Node-RED_OpenHAB_Projects_Pure-FTPd_02.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/13405dd7007b0262f1c3b77a0aa325bc/e9beb/Node-RED_OpenHAB_Projects_Pure-FTPd_02.png",
              "alt": "INSTAR Camera FTP Setup",
              "title": "INSTAR Camera FTP Setup",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Dein Test-Upload sollte unten aufgeführt sein - eine JPG-Bilddatei mit einem Namen, der mit einem `}<em parentName="p">{`T`}</em>{` gefolgt von einem `}<em parentName="p">{`Zeitstempel`}</em>{` beginnt:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/8497b9b3052260f37fae23bf4985e76f/e9beb/Node-RED_OpenHAB_Projects_Pure-FTPd_03.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "4.3478260869565215%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAABCAYAAADeko4lAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAATElEQVQI1wXBUQ5AMBBAQTeSkvJXJC21W1ZFev+bPDNdiAGxldoSYgtv27neDbWVrImoB1ILhxVSVrI+yP0RxbBykkPP6Aem2eEnxw/FRiRaxkmYtwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8497b9b3052260f37fae23bf4985e76f/e4706/Node-RED_OpenHAB_Projects_Pure-FTPd_03.avif 230w", "/de/static/8497b9b3052260f37fae23bf4985e76f/d1af7/Node-RED_OpenHAB_Projects_Pure-FTPd_03.avif 460w", "/de/static/8497b9b3052260f37fae23bf4985e76f/b6582/Node-RED_OpenHAB_Projects_Pure-FTPd_03.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/8497b9b3052260f37fae23bf4985e76f/a0b58/Node-RED_OpenHAB_Projects_Pure-FTPd_03.webp 230w", "/de/static/8497b9b3052260f37fae23bf4985e76f/bc10c/Node-RED_OpenHAB_Projects_Pure-FTPd_03.webp 460w", "/de/static/8497b9b3052260f37fae23bf4985e76f/87ca7/Node-RED_OpenHAB_Projects_Pure-FTPd_03.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8497b9b3052260f37fae23bf4985e76f/81c8e/Node-RED_OpenHAB_Projects_Pure-FTPd_03.png 230w", "/de/static/8497b9b3052260f37fae23bf4985e76f/08a84/Node-RED_OpenHAB_Projects_Pure-FTPd_03.png 460w", "/de/static/8497b9b3052260f37fae23bf4985e76f/e9beb/Node-RED_OpenHAB_Projects_Pure-FTPd_03.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/8497b9b3052260f37fae23bf4985e76f/e9beb/Node-RED_OpenHAB_Projects_Pure-FTPd_03.png",
              "alt": "INSTAR Camera FTP Setup",
              "title": "INSTAR Camera FTP Setup",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      